import posthog from 'posthog-js';
import * as Sentry from '@sentry/react';

/**
 * Thin, fail-safe telemetry facade for the Feedback Dashboard.
 *
 * Split of responsibilities:
 *   PostHog  → product/usage events (sign-in, page views, key actions). Cheap, append-only.
 *   Sentry   → crashes + handled errors.
 *   Firestore `auditLog/` (server-side) → compliance mutations. NOT here.
 *
 * Every call is wrapped so a missing/disabled SDK never throws into a user flow.
 */

/** Attach a stable identity to all subsequent events + error reports. */
export function identifyUser(uid, props = {}) {
  try { posthog.identify(uid, props); } catch { /* not initialised */ }
  try { Sentry.setUser({ id: uid, ...props }); } catch { /* not initialised */ }
}

/** Clear identity on sign-out. */
export function resetUser() {
  try { posthog.reset(); } catch { /* ignore */ }
  try { Sentry.setUser(null); } catch { /* ignore */ }
}

/** Record a named product event (PostHog only — never a Firestore write). */
export function track(event, props) {
  try { posthog.capture(event, props); } catch { /* ignore */ }
}

/** Report a handled error to Sentry with optional context. */
export function reportError(error, context) {
  try {
    Sentry.captureException(error, context ? { extra: context } : undefined);
  } catch { /* ignore */ }
}
